import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import DialogContent from '@material-ui/core/DialogContent'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import ReactMarkdown from 'react-markdown'
import * as pageTextActions from '../../store/page-texts'
import Y from '../../y18n'
import Styles from '../../common/styles'

const mapStateToProps = state => ({
  pageTexts: state.pageTexts,
  locales: state.locales
})

const mapDispatchToProps = dispatch => ({
  pageTextActions: bindActionCreators(pageTextActions, dispatch)
})

class TermsAndConditionsDialog extends Component {
  state = {
    content: ''
  }

  componentDidMount () {
    this.props.pageTextActions
      .getPageText('TermsAndConditionsPage', this.props.locales.country, this.props.locales.language)
      .then(res => {
        this.setState({ content: this.props.pageTexts.item.content })
      })
  }

  render () {
    const { classes } = this.props
    if (!this.props.open) return null
    return (
      <Dialog
        open
        onClose={() => this.props.onClose('termsOpen')}
        scroll='paper'
        classes={{
          paper: classes.dialogContent
        }}
      >
        <DialogContent>
          <div className={classes.content} style={{ padding: '0px' }}>
            <ReactMarkdown source={this.state.content} />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.props.onClose('termsOpen')}>{Y`Close`}</Button>
        </DialogActions>
      </Dialog>
    )
  }
}

TermsAndConditionsDialog = connect(mapStateToProps, mapDispatchToProps)(TermsAndConditionsDialog)
export default withStyles(Styles)(TermsAndConditionsDialog)



// WEBPACK FOOTER //
// ./src/pages/account/terms-and-conditions-dialog.js